// extracted by mini-css-extract-plugin
var _1 = "rpfDho_QGRCVBAMUHUep";
var _2 = "Ti2bA1fkxvD5gZG8ir9o";
export { _1 as "root", _2 as "text" }
